const SITE_DOMAIN = 'fleetwoodusa.com';
const FIND_A_DEALER_PATH = '/find-a-dealer';

const isFleetwoodSite = () =>
  // eslint-disable-next-line no-undef
  typeof PB_SITE !== 'undefined' && (PB_SITE === SITE_DOMAIN || PB_SITE.endsWith(`.${SITE_DOMAIN}`));

const trackFleetwoodDealerEmails = root => {
  if (!root) return undefined;
  if (!isFleetwoodSite()) return undefined;
  if (typeof window === 'undefined' || !window.location.pathname.includes(FIND_A_DEALER_PATH)) return undefined;

  const applyAttrs = link => {
    link.setAttribute('data-track', 'email');
    const region = link.closest('[data-am-region]')?.dataset?.amRegion;
    if (region) link.setAttribute('data-track-professional-type', `fleetwood ${region.toLowerCase()}`);
    const mediaBodyParent = link.closest('.media-body')?.parentElement;
    const name = mediaBodyParent?.getAttribute('aria-label');
    if (name) link.setAttribute('data-track-professional-name', name);
    if (mediaBodyParent?.getAttribute('data-track') === 'learn-more') {
      mediaBodyParent.removeAttribute('data-track');
    }
  };

  const applyAll = () => root.querySelectorAll('a[href^="mailto:"]').forEach(applyAttrs);
  applyAll();

  const observer = new MutationObserver(applyAll);
  observer.observe(root, { childList: true, subtree: true });
  return () => observer.disconnect();
};

export default trackFleetwoodDealerEmails;
